interface LogicLineMarkProps {
  height?: number;
  onBlue?: boolean;
}

export function LogicLineMark({ height = 22, onBlue = true }: LogicLineMarkProps) {
  return (
    <img
      src="/logicline-logo.png"
      alt="LogicLine"
      style={{ height, width: "auto", display: "block", borderRadius: onBlue ? 0 : 3 }}
    />
  );
}

interface FlowMarkProps {
  size?: number;
  // Kept for compatibility with the prior SVG mock; the real PNG is a single
  // asset, so this prop is currently a no-op.
  dark?: boolean;
}

// LogicLine "Rauten" mark, served from public/ (the orange rhombi-grid PNG).
export function FlowMark({ size = 26 }: FlowMarkProps) {
  return (
    <img
      src="/rauten.png"
      alt="LogicLine"
      width={size}
      height={size}
      style={{ display: "block", flexShrink: 0, objectFit: "contain" }}
    />
  );
}

interface SpinnerProps {
  size?: number;
  color?: string;
}

export function Spinner({ size = 16, color = "#fff" }: SpinnerProps) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        border: `2px solid ${color}`,
        borderTopColor: "transparent",
        animation: "flow-spin .8s linear infinite",
      }}
    />
  );
}
